import { get } from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'react-apollo';
import { WrappedComponentProps, injectIntl } from 'react-intl';
import { Button, Icon, TypographyStyle, TypographyWeight, ThemeStyle } from '@treelab/panda';

import { Typography } from '../../../Typography';
import { ELEMENT_EDIT_TEXT } from '../../../../constants/docGen';
import { GLYPHS } from '../../../../constants/icons';
import { FIELD_GLYPH_MAP } from '../../../../constants/field';

import { IDispatch, IRootState } from '../../../../modules/stores';
import { ElementTypes } from '../../../../types/element';

import { FieldType, Header, HeaderContent } from './styled';

type IConnectProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;
interface IProps extends IConnectProps, WrappedComponentProps {
  spaceType: ElementTypes;
  fieldId: string;
  fieldAbsent: boolean;
}

const SidebarEditHeader: React.FC<IProps> = ({
  field,
  fieldAbsent,
  spaceType,
  indexDepth,
  editingAttachment,
  removeEditingSpace,
  removeIndexDepth,
  removeEditingAttachment,
  intl: { formatMessage },
}) => {
  // @ts-ignore
  const icon = fieldAbsent ? GLYPHS.WARNING : FIELD_GLYPH_MAP[field ? field.type : spaceType];

  return (
    <Header>
      <HeaderContent>
        <Icon icon={icon} size={{ height: 30 }} style={{ color: 'white' }} />
        <FieldType>
          <Typography type={TypographyStyle.LABEL2} theme={ThemeStyle.white}>
            {field || fieldAbsent
              ? formatMessage({ id: 'sidebar.header.field' })
              : formatMessage({ id: 'sidebar.header.static' })}
          </Typography>
          <Typography
            type={TypographyStyle.P1}
            weight={TypographyWeight.Medium}
            theme={ThemeStyle.white}
          >
            {fieldAbsent
              ? formatMessage({ id: 'space.error.unavailable' })
              : get(field, `name`) || get(ELEMENT_EDIT_TEXT, `${spaceType}.title`)}
          </Typography>
        </FieldType>
      </HeaderContent>

      <Button
        buttonType="text"
        icon={GLYPHS.REMOVE}
        iconSize={{ height: 12, width: 12 }}
        onClick={() => {
          editingAttachment
            ? removeEditingAttachment()
            : indexDepth.length === 0
            ? removeEditingSpace()
            : removeIndexDepth();
        }}
        colorTheme={ThemeStyle.white}
      />
    </Header>
  );
};

const mapState = ({ space, core }: IRootState, { fieldId }: { fieldId: string }) => ({
  field: core.fieldById[fieldId],
  indexDepth: space.indexDepth,
  editingAttachment: space.editingAttachment,
});

const mapDispatch = ({ space }: IDispatch) => ({
  removeEditingSpace: space.removeEditingSpace,
  removeIndexDepth: space.removeIndexDepth,
  removeEditingAttachment: space.removeEditingAttachment,
});

export default compose(
  injectIntl,
  connect(
    mapState,
    // @ts-ignore
    mapDispatch,
  ),
)(SidebarEditHeader);
